import BoletoDownloadIconButton from "components/_refactor/buttons/boleto-download-icon-button";
import { columnTextField, columnNumberField } from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";

export default function TableTitulosEmAtraso({ data }) {
  const columnModel = [
    columnNumberField({
      dataField: "NumeroTitulo",
      text: "Nr. Título",
    }),
    columnTextField({
      dataField: "DataVencimento",
      text: "Vencimento",
    }),
    columnTextField({
      dataField: "DiasAtraso",
      text: "Dias em Atraso",
      headerAlign: "center",
      align: "center",
    }),
    columnTextField({
      dataField: "Valor",
      text: "Valor",
      formatter: (value) => (value ? `R$ ${value}` : ""),
    }),
    columnTextField({
      dataField: "actions",
      text: "",
      align: "center",
      formatter: (_, row) => (
        <BoletoDownloadIconButton
          row={row}
          origem="lojista-360"
          icon="document"
        />
      ),
    }),
  ];

  return (
    <ToolkitTable
      dataTable={data || []}
      columnModel={columnModel}
      keyField="NumeroTitulo"
      pagination={{
        options: [10, 25, 50, 100],
        defaultOption: 10,
        totalSize: data.length,
        showTotal: true,
      }}
      style={{
        boxShadow: "none",
        margin: "0 -1rem",
      }}
    />
  );
}
